import React from "react"

export default function SelectColumnFilterMemberPartner({ column: { filterValue, setFilter } }) {
  return (
    <select
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined)
      }}
    >
      <option value="">All</option>
      <option value="1">Member</option>
      <option value="0">Partner</option>
    </select>
  )
}
